import React from 'react';

export const Button = ({ text, dark, onClick }) => {
    return (
        <button onClick={onClick ? onClick : null} type="button" className={`spacing_1 mb-2 btn main_btn rounded-pill w-100 text-uppercase font-weight-bold ${dark ? 'btn-black text-white' : ''}`}> {text}</button>
    )
};
